import React from 'react';
import ReactDOM from 'react-dom/client';
import { RouterProvider, createBrowserRouter } from 'react-router-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { CartProvider } from './context/CartContext';
import { CustomerAuthProvider } from './context/CustomerAuthContext';
import { ToastProvider } from './hooks/useToast';
import Toaster from './components/ui/Toaster';
import CookieConsent from './components/CookieConsent';

const router = createBrowserRouter([
  {
    path: '*',
    element: <App />,
  },
]);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <CustomerAuthProvider>
      <CartProvider>
        <ToastProvider>
          <RouterProvider router={router} />
          <CookieConsent />
          <Toaster />
        </ToastProvider>
      </CartProvider>
    </CustomerAuthProvider>
  </React.StrictMode>
);

reportWebVitals();
